import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { getCompanyUsers } from '../../../slices/auth/settings/thunk';
import 'datatables.net-buttons-bs5';
import 'datatables.net-responsive-bs5';
import { setSelectedUserId, setUserPermission } from '../../../slices/auth/settings/reducer';
import { setUserModalData, setUserModalType, toggleActivateUserModal, toggleDeleteUserModal, toggleUserModal } from '../../../slices/modals/reducer';
import SortingAndFilters from '../../Feeds/Feed/SortingAndFilters';
import { getOtherUserPermission } from '../../../slices/auth/permission/thunk';
import { toast } from 'react-toastify';
import { setInnerPreloader } from '../../../slices/layouts/reducer';
const $ = require("jquery");
$.DataTable = require("datatables.net-bs5");

/**
 * @component
 * Represents the UserListTable component, which displays and manages user information, including adding, deleting, and editing users.
 */
function UserListTable() {
  const dispatch = useDispatch();

  useEffect(() => {
    async function getUsers() {
      // dispatch(setInnerPreloader(true));
      // await 
      // dispatch(setInnerPreloader(false));
    }
    // getUsers();
    dispatch(getCompanyUsers());
  }, [dispatch]);

  // Company User List Table 
  const [companyUsers, setCompanyUsers] = useState([]);
  const selectUsersData = createSelector(
    (state) => state.Settings,
    (state) => state.userList
  );
  const userList = useSelector(selectUsersData);

  useEffect(() => {
    if (userList !== null) {
      setCompanyUsers(userList);
    }
  }, [userList]);

  const selectMenuDataState = createSelector(state => state.MenuData, state => state.client);
  const company = useSelector(selectMenuDataState);

  const selectPermissionState = createSelector(state => state.Permission, state => state.permission);
  const permission = useSelector(selectPermissionState);

  // Table
  /* eslint-disable no-unused-vars */
  const tableRef = useRef();
  useEffect(() => {
    if (companyUsers !== null) {
      try {
        const table = $(tableRef.current).DataTable({
          data: companyUsers,
          columns: [
            // {
            //   data: null,
            //   title: "<input type='checkbox' class='form-check-input' />",
            //   orderable: false,
            //   render: () => {
            //     return "<input type='checkbox' class='form-check-input' />";
            //   }
            // },
            {
              data: null,
              title: "User Name",
              render: (data, type, row) => { // es-lint-disable-line
                return `${row.firstName} ${row.lastName}`;
              }
            },
            {
              data: "role",
              title: "User Role",
            },
            {
              data: null,
              title: "Date Joined",
              render: (data, type, row) => {
                if (row.hasOwnProperty('joiningDate')) {
                  return formatDate(Number(row.joiningDate));
                } else {
                  return "";
                }
              }
            },
            {
              data: null,
              title: "Last Login",
              render: (data, type, row) => {
                if (row.hasOwnProperty('lastLogin')) {
                  return formatDate(row.lastLogin);
                } else {
                  return "";
                }
              }
            },
            {
              data: "status",
              title: "User Status",
              render: (data, type, row) => {
                switch (data) {
                  case true:
                    if (row?.inviteAccepted === true) {
                      return `<span class="badge bg-success-subtle text-primary fs-11 text-uppercase">
                          <i class="ri-checkbox-circle-line align-bottom"></i> Active
                        </span>`;
                    } else if (row?.inviteAccepted === false) {
                    return  `<span class="badge bg-warning-subtle text-primary fs-11 text-uppercase">
                              <i class="ri-checkbox-circle-line align-bottom"></i> Invite sent
                            </span>`
                    }
                  case false:
                    return `<span class="badge bg-danger text-white fs-11 text-uppercase">
                              <i class="ri-close-circle-line align-bottom"></i> Inactive
                            </span>`;
                }
              }
            },
            {
              data: null,
              title: "Action",
              render: (data, type, row) => {
                let actionButtons = ``;
                if (permission.companies?.[company._id].permissionsWK.includes("userEdit")) {
                  actionButtons += `<div class='edit'>
                                      <button
                                          class='btn btn-sm edit-item-btn text-muted fs-14'
                                      >
                                          <i class='ri-pencil-fill align-bottom'></i>
                                      </button>
                                  </div>`;
                }
                if (permission.companies?.[company._id].permissionsWK.includes("userDelete")) {
                  if (row.status === true) {
                    actionButtons += `<div class='remove'>
                    <button
                        class='btn btn-sm remove-item-btn text-muted fs-14'
                    >

                        <i class="ri-delete-bin-fill align-bottom"></i>
                    </button>
                </div>`;
                  } else {
                    actionButtons += `<div class='remove'>
                    <button
                        class='btn btn-sm remove-item-btn text-muted fs-14'
                    >

                        <i class="ri-lock-unlock-fill align-bottom"></i>
                    </button>
                </div>`;
                  }

                }
                return `<div class='d-flex gap-1'>${actionButtons}</div>`;
              }
            }
          ],
          responsive: true,
          columnDefs: [
            { responsivePriority: 1, targets: [1, -2] },
            { responsivePriority: 2, targets: "_all" }
          ],
          language: {
            search: "<i class='ri-search-line search-icon'></i>",
            searchPlaceholder: "Search for users..."
          },
          info: false,
          destroy: true,
        });
        /* eslint-enable no-unused-vars */

        table.on("click", ".edit", async function () {
          let tr = $(this).closest("tr");
          if ($(tr).hasClass("child")) {
            tr = $(tr).prev();
          }
          let data = table.row(tr).data();
          if (data) {
            dispatch(setUserModalType("edit"));
            dispatch(toggleUserModal());
            dispatch(setUserModalData(data));
            dispatch(setUserPermission(null));
            dispatch(getOtherUserPermission(data._id));
          }
        });

        table.on("click", ".remove", function () {
          let tr = $(this).closest("tr");
          if ($(tr).hasClass("child")) {
            tr = $(tr).prev();
          }
          let data = table.row(tr).data();
          if (data) {
            dispatch(setSelectedUserId(data._id));
            if (data.status === true) {
              dispatch(toggleDeleteUserModal());
            } else {
              dispatch(toggleActivateUserModal());
            }
          }
        });

        return function () {
          table.destroy();
        }
      } catch (error) {
        toast.error('Something went wrong', { autoClose: 3000 })
      }
    }
  }, [companyUsers]);

  /**
   * Formats a given date string into a human-readable date format.
   *
   * @param {string} dateString - The input date string to be formatted.
   * @returns {string} The formatted date in the "day month, year" format.
  */
  function formatDate(dateString) {
    const date = new Date(dateString);

    const formatter = new Intl.DateTimeFormat("en", { month: "short" });
    const day = date.getDate();
    const month = formatter.format(date);
    const year = date.getFullYear();

    return `${day} ${month}, ${year}`;
  }
  return (
    <div>
      <table className='align-middle table-nowrap mb-0 table' style={{ width: "100%" }} ref={tableRef}>
        <thead className='table-light'></thead>
        <tbody></tbody>
      </table>
    </div>
  )
}

export default UserListTable;